import { ArrowRepeat } from "react-bootstrap-icons";

//Common
import useIconStyles from "./styles";
import { IconProps } from "../../../types";

const ResetIcon = (props: IconProps) => {
    const { iconText = "Reset Password", pendingText } = props;
    const iconStyles = useIconStyles();

    return (
        <div style={iconStyles.container}>
            <ArrowRepeat style={iconStyles.viewIcon}  />
            <div style={iconStyles.iconText}>
                {iconText} {pendingText}
            </div>
        </div>
    );
};

export default ResetIcon;
